import { FETCH_CARMAKEMODALVARIANT_FAILURE, FETCH_CARMAKEMODALVARIANT_REQUEST, FETCH_CARMAKEMODALVARIANT_SUCCESS } from "../actions/types";

const initialState = {
    data: [],
    error: ''
};

export const carMakeModalVariant = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_CARMAKEMODALVARIANT_REQUEST:
            return {
                ...state,
            }
        case FETCH_CARMAKEMODALVARIANT_SUCCESS:
            return {
                data: action.payload
            }
        case FETCH_CARMAKEMODALVARIANT_FAILURE:
            return {
                data: [],
                error: action.payload
            }
        default:
            return state;
    }
}